export interface ScoreMethodDto {
  ScoreMethodID: number;
  Name: string;
}
